/*
* This file contain api requests 
*/
import 'whatwg-fetch';
import _ from 'lodash';

import env from '../config/env.js'
const apiUrl=env.apiUrl;
const stripePublishableKey=env.stripePublishableKey;
function checkStatus(response) {
  if( response.status === 401 ) {
    window.localStorage.removeItem('agl-token');
    window.localStorage.removeItem('userType');
    window.location = '/login'; // TODO: This should use the router?
  }

  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    console.warn("Error in HTTP Request", response.status, response);
    error.response = response;
    if( response.json ) {
      throw response.json();
    }
    else {
      throw error;
    }
  }
}
function parseJSON(response) {
  return response.json();
}

export const authenticate = (username, password) => {
  return fetch(apiUrl+`/api/authenticate`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      username: username,
      password: password
    })
  }).then(parseJSON).then((json) => {
    return json;
  });
};
export const authenticateUserEmail = (username) => {
  return fetch(apiUrl+`/api/authenticateUserEmail`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      username: username
    })
  }).then(parseJSON).then((json) => {
    return json;
  });
};


export const fetchManuals = (companyid) => {
  return fetch(apiUrl+'/signup/company/manuals', {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      companyid: companyid
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const fetchTemplates = (manualId) => {
  return fetch(apiUrl+`/signup/company/manuals/${manualId}/templates`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const updateTemplateParams = (manualId, templateId, params) => {
  return fetch(apiUrl+`/api/manuals/${manualId}/templates/${templateId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      parameters: params
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const uploadTemplateFile = (manualId, templateId, companyId, files) => {
  var formData = new FormData();
  if( _.isArray(files) ) {
    formData.append('file', files[0]);
  }
  else {
    return;
  }

  return fetch(apiUrl+`/api/manuals/${manualId}/templates/${templateId}/company/${companyId}`, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    body: formData
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const uploadNewTemplateFile = (manualId, templateId, companyId, files, newTemplateName) => {
  var formData = new FormData();
  if( _.isArray(files) ) {
    formData.append('file', files[0]);
  }
  else {
    return;
  }

  return fetch(apiUrl+`/api/manuals/addnewfile/${manualId}/templates/${templateId}/company/${companyId}/${newTemplateName}`, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    body: formData
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const fetchJobs = (compId) => {
  return fetch(apiUrl+`/api/jobs/${compId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const fetchJob = (jobId) => {
  return fetch(apiUrl+`/api/jobs/singlejob/${jobId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const importJob = (jobId,companyId,simproCompId) => {
  // const tokenstatus = window.localStorage.getItem('tokenStatus');
  return fetch(apiUrl+'/api/jobs', {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      id: jobId,
      companyid: companyId,
      simproCompId: simproCompId,
      // tokenStatus: tokenStatus
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function getCompaniesFromApi(companyid){
  return fetch(apiUrl+`/api/jobs/simprpo/comapnies/${companyid}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET',
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export const refreshJob = (jobId) => {
  return fetch(apiUrl+`/api/jobs/${jobId}/refresh`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST'
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function fetchJobStatus(jobId,compId){
 
  return fetch(apiUrl+`/api/jobs/${jobId}/status/${compId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET'
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });

}

export const deleteJob = (jobId, job) => {
  return fetch(apiUrl+`/api/jobs/deletejob/${jobId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'DELETE',
    body: JSON.stringify(job)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const updateJob = (jobId, job) => {
  return fetch(apiUrl+`/api/jobs/${jobId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(job)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const uploadJobFile = (jobId, fileType, files) => {
  var formData = new FormData();
  formData.append('file_type', fileType);
  if( _.isArray(files) ) {
    formData.append('file', files[0]);
  }
  else {
    return;
  }

  return fetch(apiUrl+`/api/jobs/${jobId}/upload`, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    body: formData
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const createJobDocument = (jobId,compId) => {
  // 1. If we get a 503, we want to start long polling the client.
  return fetch(apiUrl+`/api/jobs/${jobId}/document/${compId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST'
  }).then(function(response) {
    if( response.status === 503 ) {
      var error = new Error('Gateway timeout');
      error.code = 503;
      throw error;
    } else {
      return response;
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const fetchUsers = () => {
  return fetch(apiUrl+`/api/users`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const addUser = (username, password) => {
  const user = { username, password };

  return fetch(apiUrl+`/api/users`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(user)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const deleteUser = (userId) => {
  return fetch(apiUrl+`/api/users/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'DELETE',
    body: JSON.stringify({})
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const updatePassword = (userId, password) => {
  return fetch(apiUrl+`/api/users/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({ password })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};



export function addCompany(name,email,password,selected_pms,user_name,plan,otp, plan_number){
  const company = { name,email,password,selected_pms,user_name ,plan,otp, plan_number};
  //alert(window.localStorage.getItem('agl-token'));
  return fetch(apiUrl+`/signup/company`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(company)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function validateCompany(name,email,password,selected_pms,user_name,plan){
  const company = { name,email,password,selected_pms,user_name ,plan};
  //alert(window.localStorage.getItem('agl-token'));
  return fetch(apiUrl+`/signup/company/validate`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(company)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function addSelectedManual(companyid, manuals){
  const selectedManuals = { companyid, manuals };
  //alert(window.localStorage.getItem('agl-token'));
  return fetch(apiUrl+`/signup/company/addmanuals`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(selectedManuals)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function contactNone(name,email){
  const contact = { name,email };
  return fetch(apiUrl+`/signup/company/contact_none`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(contact)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function contactOther(name,email,telephone){
  const contact = { name,email,telephone };
  return fetch(apiUrl+`/signup/company/contact_other`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(contact)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};
export function paymentRequest(request){
 
  return fetch(apiUrl+`/signup/company/payment_req`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(request)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function createPaymentIntent(request){
 
  return fetch(apiUrl+`/signup/company/create_payment_intent`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(request)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function addSimproApi(companyid,apiKey){
  const simproApikey={ companyid,apiKey };
  return fetch(apiUrl+`/signup/company/api_key`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(simproApikey)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const fetchLoginUserDetail = (pageNumber = 1) => {
  const usertype =window.localStorage.getItem('userType');
  const data= { usertype,pageNumber};
  return fetch(apiUrl+`/api/users/userdetail`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(data)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};
export function uploadCompanyLogo(formdata,compid){
  return fetch(apiUrl+`/api/company/edit/${compid}/uploadPic`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: formdata
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};
export function submitComponyEdit(compid,name,address, stripeEmail, customer_email){
  var compdata={compid,name,address, stripeEmail, customer_email};
  return fetch(apiUrl+`/api/company/editcompany`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(compdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}
export function restPassword(email,password){
  const formdata={ email,password };
  return fetch(apiUrl+`/signup/company/resetpassword`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}
// send request from support message pop form
export function supportContact(name,email,message,companyname,companyid,useremail){
  const formdata={ name,email,message,companyname,companyid,useremail };
  return fetch(apiUrl+`/api/company/supportContact`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}


export function companySubscription(companyid){
 
  return fetch(apiUrl+`/api/company/${companyid}/subscription`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET'
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export const fetchSubscription =(plan_id)=>{
  return fetch(apiUrl+'/subscriptions/'+plan_id+'/get',{
    
    method: 'GET'
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export const fetchSubscriptions =()=>{
  
  return fetch(apiUrl+'/subscriptions',{
    headers:{
      'Content-Type':'application/json',
    }
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}


export const updateCompanySubscription = (company_id,subscription_id) =>{
  return fetch(apiUrl+`/api/company/${company_id}/subscription`, {
    headers:{
      'Content-Type':'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token')
    },
    method: 'POST',
    body:JSON.stringify({subscription_id:subscription_id})
  }).then(checkStatus).then(parseJSON).then((json)=>{
    return json;
  });
}

export const sendForgatPassEmail = (username) =>{
    const email = { username};
      return fetch(apiUrl+`/api/forgetpassword`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
        },
        method: 'POST',
        body: JSON.stringify(email)
      }).then(checkStatus).then(parseJSON).then((json) => {
        return json;
      });
}

export const getLoggedInUser = () =>{
      let userType = window.localStorage.getItem('userType');
      return fetch(apiUrl+`/api/users/getloggedinuser`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
        },
        method: 'POST',
        body: JSON.stringify({userType})
      }).then(checkStatus).then(parseJSON).then((json) => {
        return json;
      });
}

export function cancelDokkit(userId, calltype){
  return fetch(apiUrl+`/api/company/cancelDokkit/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET'
  }).then(checkStatus).then(parseJSON).then((json) => {
    if(calltype !== "admin_company_listing"){
      window.localStorage.removeItem('agl-token');
    }
    return json;
  });
}

export function sendMailCancelDokkit(message, userId){
  return fetch(apiUrl+`/sendMailCancelDokkit`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      message,
      userId
    })
  }).then(parseJSON).then((json) => {
    return json;
  });
}
export function authorizeApi(companyid,url,simprouser,simpropass,check, redirectUrl){
  return fetch(apiUrl+`/signup/company/auth/simpro`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      companyid: companyid,
      url: url,
      simprouser:simprouser,
      simpropass:simpropass,
      check: check,
      redirectUrl: redirectUrl,
    })
  }).then(parseJSON).then((json) => {
    if(json.uri=='' || json.error && json.error!=''){
      var error = new Error('Incorrect URL.');
      throw error;
    }else{

      // Set identifier in case of forcefully re-authorisation  by admin, so that we can show succcess message after successfully authorisation
      if(redirectUrl){
        window.localStorage.setItem('force_reauthorised', companyid);
      }else{
        window.localStorage.removeItem('force_reauthorised');
      }

      window.location=json.uri;
    }
    //return json;
  });
}

export function verifyUserPass(url,simprouser,simpropass, companyId){
  return fetch(apiUrl+`/signup/company/verify/simpro`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      simprouser:simprouser,
      simpropass:simpropass,
      url: url,
      companyId: companyId
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export function checkCompaniesFromApi(companyid){
  return fetch(apiUrl+`/signup/company/simpro/checkcompany/${companyid}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET',
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export function updateFromFreetrial(compId){
  var compdata={compId};
  return fetch(apiUrl+`/api/company/freetrialend`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(compdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}
 // to extend free trail for user by admin
export function extendFreetrial(trailend, allowance, compId, allowChanges){
  var compdata={
    trailend: trailend,
    allowance: allowance,
    compId: compId,
    allowChanges: allowChanges
      };
  return fetch(apiUrl+`/api/company/extendfreetrial`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(compdata),
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}
 // to get comapny trail end date and allowance for admin panel
export function getSubscriptionhistoryData(compId,activePage){
  var compdata={
    compId: compId,
    activePage:activePage,
      };
  return fetch(apiUrl+`/api/company/getSubsData`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(compdata),
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export function addNewManual(newManuals, companyid, tmpSetId) {
  let manuals = { newManuals , companyid, tmpSetId };
  return fetch(apiUrl+'/api/manuals/addnewtemplate', {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(manuals)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export function removeCompanyTemplate(companyid, groupName, tmpSetId) {
  let manuals = { companyid, groupName, tmpSetId };
  return fetch(apiUrl+'/api/manuals/removetemplate', {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(manuals)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export const reimportJob = (jobId,companyId,simproCompId, tokenStatus) => {
  return fetch(apiUrl+`/api/jobs/reimport/${jobId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      id: jobId,
      companyid: companyId,
      simproCompId: simproCompId,
      tokenStatus: tokenStatus
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const sendToSimpro = (companyId, jobId, simpro_company_id, createdManualUrl) => {
  return fetch(apiUrl+`/api/jobs/sendtosimpro/${jobId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      jobId: jobId,
      companyId: companyId,
      createdManualUrl: createdManualUrl,
      simpro_company_id: simpro_company_id
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const getCompanyDataForPayment = (companyId) =>{
  return fetch(apiUrl+`/api/company/getcompanydata/${companyId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      companyId: companyId,
    }).then(checkStatus).then(parseJSON).then((json) => {
      return json;
    })
  })
}

export const setMainTemplateToUse = (companyid, groupname, templateid) => {
  const data = { companyid, groupname, templateid };
  return fetch(apiUrl+`/api/manuals/setmaintemplatetouse`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(data)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export const findAllEncryptedFiles = (files, cloudConvertRes, type) => {
  return fetch(apiUrl+`/api/jobs/fetchallencyptedfiles`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      files: files,
      cloudConvertRes: cloudConvertRes,
      type: type
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

/*
Created by : Rahul Kumar
Created on : 07-11-2019
Purppose: function to call API to fetch company template sets
*/


export const getTemplateSet = (companyId, calltype) => {
   
   let apiLink = apiUrl+`/api/company/templateset/${companyId}`;
   if(calltype){
       apiLink = apiLink+`?_calltype=details`;
   }
  return fetch(apiLink, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET',
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
  
};



/*
Created by : Rahul Kumar
Created on : 08-11-2019
Purppose: function to call API to save new template sets
*/


export const saveTemplateSet = (manualId, formData) => {
   
   let apiLink = apiUrl+`/api/company/templateset/${manualId}`;
  return fetch(apiLink, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formData)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};


/*
Created by : Rahul Kumar
Created on : 11-11-2019
Purppose: function to call API to delete new template sets
*/


export const deleteTemplateSet = (tmpSetId) => {
   
   let apiLink = apiUrl+`/api/company/templateset/${tmpSetId}`;
  return fetch(apiLink, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'DELETE',
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};


/*

Created by : Rahul Kumar
Created on : 20-12-2019
Purppose: function to get system logs
*/


export const getSystemLogs = (args) => {
   let apiLink = apiUrl+`/api/system/logs?older=${args.older}`;
  return fetch(apiLink, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET',
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

/*

Created by : Rahul Kumar
Created on : 23-12-2019
Purppose: function to get system logs
*/


export const importSystemLogs = (args) => {
   let apiLink = apiUrl+`/api/system/logs?type=${args.type}`;
  return fetch(apiLink, {
    headers: {
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'GET',
  }).then(response => response.blob()).then((blob) => {
    return blob;
  });
};

/*

Created by : Aakash bhagat
Created on : 25-05-2020
Purppose: function to update attachment order
*/
export function setAttachment(companyid, stockPartsAttachment, manaulsAttachment) {
  let params = {stockPartsAttachment, manaulsAttachment };
  return fetch(apiUrl+`/signup/company/attachment/order/${companyid}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(params)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
}

export const updateSimproDetails = (username,password,companyid) => {
  return fetch(apiUrl+`/signup/company/simpro/update/${companyid}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      simprouser:username,
      simpropass:password
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};


/*
Created by : Aakash bhagat
Created on : 25-05-2020
Purppose: when we cancel stripe from model cancel text then next
 time we get directly paid for trial subscription this function
 will call on every error from modal by which this strange bug woul de be handled
*/

export const  modalCancelHandlerStripe = (setup_intent_id, client_secret) => {
  return fetch('https://api.stripe.com/v1/setup_intents/'+setup_intent_id+'?key='+stripePublishableKey+'&is_stripe_sdk=false&client_secret='+client_secret,
  {  
    method: 'GET' 
  }).then(checkStatus).then(parseJSON).then((json)=>{
    return json
  })
}

export const searchCompany = (search,activePage) => {
  return fetch(apiUrl+`/api/company/search`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      search:search,
      active_page:activePage
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};
export const searchJob = (search,id,activePage) => {
  
  return fetch(apiUrl+`/api/company/jobs/search`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify({
      search:search,
      company_id:id,
      active_page:activePage
    })
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};


// WEBPACK FOOTER //
// ./src/api/index.js